import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  getSchedules(payload) {
    return Api(payload).post(
      "/api/admin/schedulecomments/getschedules?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy,
      payload
    );
  },
  GetComments() {
    return Api().get("/api/admin/schedulecomments/comments");
  },
  GetScheduleShowObj(payload) {
    return Api().post(
      "/api/admin/schedulecomments/getscheduleshowobj",
      payload
    );
  },
  AddScheduleComment(payload) {
    return Api().post("/api/admin/schedulecomments/schedulecomment", payload);
  },
  GetScheduleComment(payload) {
    return Api().post(
      "/api/admin/schedulecomments/getschedulecomment",
      payload
    );
  },
  GetStatuses(payload) {
    console.log("Payload", payload);
    const query = createQueryString(payload);
    console.log("query", query);
    return Api().get(`/api/admin/schedulecomments/getstatuses${query}`);
  },
  GetScheduleTransactions(payload) {
    return Api().post(
      "/api/admin/schedulecomments/getscheduletransactions",
      payload
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/ScheduleCommentsService.js